import { type ReactNode } from 'react';
import type { Payment } from '../types';
import { PaymentColumn } from './payment-column';
import { PaymentCard } from './payment-card';
import { PaymentColumnSkeleton } from './payment-skeleton';

function sumEarnings(items: Payment[]): number {
  return items.reduce((s, p) => s + p.total_earnings, 0);
}

function byEarningsDesc(items: Payment[]): Payment[] {
  return [...items].sort((a, b) => b.total_earnings - a.total_earnings);
}

export function PendingCol({
  items,
  loading,
}: {
  items: Payment[];
  loading: boolean;
}): ReactNode {
  // items llegan ya filtrados por el modo (+$100 / Completo); el total
  // de la cabecera es el "total a pagar" de lo que se está viendo.
  const sorted = byEarningsDesc(items);
  return (
    <PaymentColumn
      status="pending"
      label="Pendiente de Pago"
      count={items.length}
      totalAmount={sumEarnings(items)}
    >
      {loading ? (
        <PaymentColumnSkeleton count={3} />
      ) : (
        sorted.map((p) => <PaymentCard key={p.id} payment={p} />)
      )}
    </PaymentColumn>
  );
}

export function PaidCol({
  items,
  loading,
}: {
  items: Payment[];
  loading: boolean;
}): ReactNode {
  const sorted = byEarningsDesc(items);
  return (
    <PaymentColumn
      status="paid"
      label="Pagado"
      count={items.length}
      totalAmount={sumEarnings(items)}
    >
      {loading ? (
        <PaymentColumnSkeleton count={4} />
      ) : (
        sorted.map((p) => <PaymentCard key={p.id} payment={p} />)
      )}
    </PaymentColumn>
  );
}
